import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hej, mitt namn är Johan Rytterfelt`}</h1>
    <p>{`Jag är en webbutvecklare som har erfarenhet av att bygga webbsystem, hybridappar, och självklart vanliga webbsidor.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      